import { Avatar, Badge, Box, Button, Card, Chip, Grid, IconButton, InputAdornment, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Edit, RemoveRedEye, RestartAlt, Search } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { ProviderWalletServices } from './services';

import MultiColumnFilter from '../../components/Filter/MultiColumnFilter';
import { PermissionGuard } from '../../components/PermissionGuard';
import { formatDateTime } from '../../utils/dateUtils';
import Loading from '../../components/Loader/Loading';
import { Helpers } from '../../services/Helpers';

const WalletList = () => {
  const navigate = useNavigate();
  // State to store the total row count inititally before server respond
  const [rowCount, setRowCount] = useState(5);

  // State to store the row count used by the DataGrid
  const [rowCountState, setRowCountState] = useState(rowCount);

  // Update rowCountState whenever rowCount changes
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState,
    );
  }, [rowCount, setRowCountState]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
    filters: {
      searchKey: "",
      sortKey: 'updatedAt',
      sortDirection: 'desc',
      filterOptions: [
        {
          fieldName: 'isTester',
          operator: 'equals',
          value: 'false'
        }
      ]
    }
  });

  const handlePaginationModel = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortKey,
      sort: paginationModel.filters.sortDirection,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortKey: newSortModel[0].field,
          sortDirection: newSortModel[0].sort
        }
      }));
    }
  }
  const columns = [
    {
      field: 'provider', headerName: `Expert Detail's`, flex: 1.5, headerAlign: 'center',sortable:false,
      renderCell: (params) => (
      
      
              <Box sx={{ p: 1, display: { xs: 'block', sm: 'flex' }, justifyContent: 'flex-start', width: '100%' }}>
                
                  <Box sx={{ display: { xs: 'block', sm: 'flex' }, gap: '5%', justifyContent: 'flex-start', width: '100%' }}>
                    <Avatar src={`${Helpers.ImagePathUrl()}/profile/sm/${params.row.expert?.UserProfile?.profileImage}`} />
                    <Box>
                      <Typography
                        onClick={(e) => window.open(`/admin/expert-detail/${params.row.expert.id}`, '_blank')}
                        variant="body2"
                        sx={{
                          cursor: 'pointer', fontSize: '.65rem', fontWeight: 500,
                          //on hover color
                          '&:hover': {
                            color: 'warning.main'
                          }
                        }}
                        color={params.row.expert?.UserProfile?.firstName ? '#1976d2' : '#d32f2f'}
                      >
                        {params.row.expert?.UserProfile?.firstName} {params.row.expert?.UserProfile?.middleName} {params.row.expert?.UserProfile?.lastName}
                        {!params.row.expert?.UserProfile?.firstName && 'Incomplete Profile'}
                        <Box component={'span'} sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>({params.row.expert?.id})</Box>
                        {params.row?.expert?.isTester &&
                                          <Chip
                                          label={"Tester"}
                                          color="primary"
                                          variant="outlined"
                                          size="small" 
                                          sx={{ml:1,fontSize:'0.5rem',height:'fit-content','& .MuiChip-icon':{fontSize:'0.65rem'},color: '#ffffff',
                                                bgcolor:'#000000'}}
                                        />
                                        }
                      </Typography>
                      <Box>
                        
                        <Typography variant="caption" sx={{ fontSize: '0.5rem' }}>{params.row.expert?.UserProfile?.email || 'N/A'}</Typography>
                        <Typography sx={{ fontSize: '0.5rem' }}> <Box component={'span'} sx={{ fontWeight: 600 }}>Mobile:</Box>{` ${params.row.expert?.mobileNumber}`}</Typography>
                      </Box>
                    </Box>
      
                  </Box>
              </Box>
            ),
    },
    {
      field: 'title', headerName: 'Title', flex: 1.5, headerAlign: 'center',sortable:false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'center',width:'100%' }}>
          <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
        </Box>
      ),
    },  
    {
      field:'stats',headerName: `Last Transaction`,flex:1,headerAlign:'center',sortable:false,
      renderCell: (params) => (
        <Box sx={{display:'flex',flexDirection:'column',gap:1,p:1,width:'100%'}}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>Type</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%'}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>
              <Chip 
                size="small" 
                label={params.row.creditAmount > 0 ? 'Credit' : 'Debit'} 
                color={params.row.creditAmount > 0 ? 'success' : 'error'}
                sx={{ fontSize: '0.5rem', height: 'fit-content', py: '5%' }}
              />
            </Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>Prev. Balance</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%'}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>₹ {params.row.previousBalance}</Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>{params.row.creditAmount > 0 ? 'Cr. Amount' : 'Dbt. Amount'}</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%'}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>
              <Chip 
                size="small" 
                label= {params.row.creditAmount > 0 ? '₹ '+params.row.creditAmount : '₹ '+params.row.debitAmount  } 
                sx={{ fontSize: '0.5rem',fontWeight:600, height: 'fit-content', py: '5%', bgcolor: '#242222a8',color:'#fff' }}
              />
            </Typography>
          </Box>
        </Box>
      ),
    },
    {
      field: 'currentBalance',headerName: 'Current Balance',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}> 
          <Chip 
            size="small" 
            label={`₹ ${params.row.currentBalance}`} 
            //>0 success, =0 warning, <0 error
            color={params.row.currentBalance > 0 ? 'success' : params.row.currentBalance == 0 ? 'info' : 'error'}
            sx={{fontSize:'0.65rem',}}
          />
        </Typography>
      ),
    },
    {
      field: 'createdAt',headerName: 'Transaction Date',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>{params.row.createdAt && formatDateTime(params.row.createdAt)}</Typography>
      ),
    },
  ]
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const fetchNotificationList = async () => {
    setIsloading(true);
    try {
      const notificationResponse = await ProviderWalletServices.fetchWalletList({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortKey: paginationModel.filters.sortKey,
          sortDirection: paginationModel.filters.sortDirection,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      if (notificationResponse.success == '1') {
        setNotifications(notificationResponse.data);
        setRowCount(notificationResponse.totalItems);
      } else if (notificationResponse.success == '0') {
        console.log("Error fetching Notifications:", notificationResponse.message);
      }
    } catch (error) {
      console.log("Error fetching Notifications:", error)
    } finally { setIsloading(false); }
  }
  useEffect(() => {
    fetchNotificationList();
  }, [paginationModel])

  const filterableColumns = [
    {
      key: 'isTester',
      label: 'Is Tester',
      type: 'select',
      options: [
        { value: 'true', label: 'True' },
        { value: 'false', label: 'False' }
      ]
    },
    {
      key: 'title',
      label: 'Title',
      type: 'text'
    },
    {
      key: 'currentBalance',
      label: 'Current Balance',
      type: 'number'
    },
    {
      key: 'createdAt',
      label: 'Transaction Date',
      type: 'date'
    },
  ];
  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
      filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  const { control, handleSubmit,getValues, reset } = useForm();
  /**** Advanced multi column filter related ****/
  const [clearMultiFilter, setClearMultiFilter] = useState(false);
  const clearFilters = () => {
      reset({
        searchKey: "",
      });
      setPaginationModel({
        ...paginationModel,
        filters: {
          ...paginationModel.filters,
          searchKey: "",
          sortBy: 'createdAt',
          sortType: 'desc',
          filterOptions: []
        }
      });
  
      // Trigger clear for MultiColumnFilter
      setClearMultiFilter(true);
  
      // Reset the clear trigger after a short delay
      setTimeout(() => setClearMultiFilter(false), 100);
  }
  function onSubmit(data) {
    const filtersData = getValues();
    setPaginationModel({
      ...paginationModel,
      filters: {
        ...paginationModel.filters,
        searchKey: filtersData.searchKey,
      }
    });
  }
  return (
    <Box>
      {/* <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
        <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Sent Notifications</Typography>
      </Box> */}
      <Card>
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              width: "100%", display: "table", tableLayout: "fixed",
              backgroundColor: "#fff", borderRadius: '.5rem',
              '& .odd': {
                bgcolor: 'white',
              },
              '& .even': {
                bgcolor: '#ECECEC',
              },
            }}>

            {isLoading && <Loading />}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                />
                {/* <ExportAll paginationModel={paginationModel} columns={columns} statusOptions={statusOptions} /> */}
              </Box>
              
              {/* <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{ fontSize: 'x-small' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box> */}
            </Box>
            <DataGrid
              rows={notifications}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
              }))}
              // getRowId={(row) => row._id}
              rowCount={rowCount}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationModel}

              // Add these props for page numbers
              showFirstButton={true}
              showLastButton={true}

              // filterModel={filterModel}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={handleSortingChange}
              disableMultiSort={true}

              loading={isLoading}
              getRowClassName={(params) => {
                // console.log("checking customer is deleted",params.row.customer?.deletedAt)
                // Check if customer is deleted
                if (params.row.customer?.deletedAt) {
                  return 'deleted-row';
                }
                // Keep alternating row colors for non-deleted rows
                return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }}

              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              sortingOrder={['asc', 'desc']}
              slots={{
                // toolbar: GridToolbar,
                loadingOverlay: Loading,
                // Optionally use custom pagination
                // pagination: CustomPagination,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,  
              //   },
              // }}
              // autoHeight
              getRowHeight={() => 'auto'}
              sx={{
                height: '69vh',
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
            />
          </Box>
        </Box>
      </Card>
    </Box>
  )
}

export default WalletList